import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const setupHero = (el) => {
  function setupScrollTrigger() {
    gsap.to(el, {
      scrollTrigger: {
        trigger: el,
        start: 'top top',
        scrub: true,
      },
      yPercent: 50,
    })
  }

  function init() {
    setupScrollTrigger()
  }

  init()
}

export default setupHero
